"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveySlider = require("cccisd-survey-slider");
var _filterProps = _interopRequireDefault(require("../filterProps.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdSurveySlider.Player, _extends({}, (0, _filterProps["default"])(props), {
    isMatrixMode: true
  }));
};
var _default = exports["default"] = {
  component: Component,
  validate: _cccisdSurveySlider.playerValidate,
  getInitialValue: _cccisdSurveySlider.getPlayerInitialValue
};